import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-24 bg-zinc-950 relative">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            {/* Decorative frame */}
            <div className="absolute -inset-4 border-2 border-zinc-800 rounded-sm translate-x-4 translate-y-4 -z-10"></div>
            <div className="absolute top-0 left-0 w-20 h-20 border-t-4 border-l-4 border-orange-500 -translate-x-2 -translate-y-2 z-10"></div>
            
            <img 
              src="https://media.wasacon.de/valerirudtmedia/_assets/media/964b6562ec26b3077398ed18592909a0.png" 
              alt="Valeri Rudt auf der Baustelle" 
              className="w-full h-auto object-cover rounded-sm grayscale hover:grayscale-0 transition-all duration-700" 
            />
          </motion.div>

          {/* Text Side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-white mb-8">
              Wer ist <br /><span className="text-orange-500">Valeri Rudt?</span>
            </h2>
            
            <div className="space-y-6 text-zinc-400 font-medium leading-relaxed">
              <p>
                Ich komme vom Bau. Das ist nicht nur ein Spruch, das ist meine Realität. Jeden Tag Staub, Lärm, harte Arbeit – und genau das liebe ich.
              </p>
              <p>
                Mein Content ist kein gestelltes Studio-Setup. Wenn ich eine Maschine teste oder ein Material zeige, dann passiert das direkt dort, wo es hingehört: <strong className="text-white">Auf der Baustelle.</strong>
              </p>
              <p>
                Ich stehe für Leidenschaft für echte Arbeit und Content ohne Fake. Direkt aus der Praxis, für Handwerker und alle, die wissen, was es heißt, sich die Hände schmutzig zu machen.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-6">
              <div className="border-l-2 border-orange-500 pl-4">
                <p className="text-3xl font-black text-white">100%</p>
                <p className="text-sm text-zinc-500 uppercase tracking-wider font-bold">Real Life</p>
              </div>
              <div className="border-l-2 border-orange-500 pl-4">
                <p className="text-3xl font-black text-white">Praxis</p>
                <p className="text-sm text-zinc-500 uppercase tracking-wider font-bold">Geprüft</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;